import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import React, {memo} from "react";
import {ModelNameMaps} from "./ModelNameMaps";
import MainModelManager from "./MainModelManager";
import { Vector3 } from "three";

const DynamicModelLoader = ({modelRef, location, fileFormat}) => {
  const currMaterialRef = Object.values(modelRef)[0].materialOverride;
  const currModelRef = Object.keys(modelRef)[0];
  const modelName = ModelNameMaps().get(currModelRef);
  
  const gltf = useLoader(GLTFLoader, location + modelName + fileFormat);
  gltf.scene.visible = true;
  
  const activeMaterials = [];
  const materialsObj = {};
  
  const meshData = [];

  gltf.scene.children.forEach(child=>{child.receiveShadow = true; child.castShadow = true;});
  
  gltf.scene.traverse(function (child) {
    
    if (child["type"] === 'Mesh') {
      
      child["geometry"].name = child["name"];

      let position = Object.values(modelRef)[0].positionOverride ? new Vector3().fromArray(Object.values(modelRef)[0].positionOverride) : child["position"];
      let scale = Object.values(modelRef)[0].scaleOverride ? new Vector3().fromArray(Object.values(modelRef)[0].scaleOverride) : child["scale"];

      meshData.push({
        geometry: child["geometry"],
        position: position,
        rotation: child["rotation"],
        material: child["material"],
        scale: scale,
        name: child["name"]
      })
    }
    
  });
  
  if (currMaterialRef) {

    if(typeof(currMaterialRef) === "string")
    // extract applied materials from meshes
    Object.keys(gltf.nodes).forEach((prop) => {
      
      if (gltf.nodes[prop]["type"] === 'Mesh') {

        gltf.nodes[prop].material.name = currModelRef;
        materialsObj['materialName'] = currMaterialRef;
        materialsObj['material'] = gltf.nodes[prop].material;
        materialsObj['name'] = currModelRef;
        activeMaterials.push(Object.assign({}, materialsObj));

      }
    });
    else if(typeof(currMaterialRef) === "object")
    {
      Object.keys(gltf.nodes).forEach((prop) => {
        
        if (gltf.nodes[prop]["type"] === 'Mesh' && Object.keys(currMaterialRef).includes(gltf.nodes[prop].material.name)) {
  
          materialsObj['materialName'] = currMaterialRef[gltf.nodes[prop].material.name];
          materialsObj['material'] = gltf.nodes[prop].material;
          materialsObj['name'] = currModelRef + "-" + gltf.nodes[prop].material.name;
          activeMaterials.push(Object.assign({}, materialsObj));
  
        }
      });
    }
  }

  
  return (
    <>
      <MainModelManager geometries={meshData} currMaterialRef={currMaterialRef} mat={activeMaterials}/>
      
      {/*<MainModelManager geometries={meshData} mainObject={gltf.scene} currMaterialRef={currMaterialRef} mat={activeMaterials}/>*/}
      {/*<primitive object={gltf.scene}/>*/}
      {/*{(currMaterialRef) && (<MaterialInitialiser activeMaterials={activeMaterials}/>)}*/}
      
      </>
  )
};

export const MemDynamicModelLoader = memo(DynamicModelLoader);
// export const MemDynamicModelLoader = DynamicModelLoader;
// export default DynamicModelLoader;
